import Add from './Add';
import Edit from './Edit';
import DTable from '../../../components/DTable/DTable';
import { CheckOutlined, ClockCircleOutlined, ExclamationCircleOutlined, TeamOutlined, IdcardOutlined, FileDoneOutlined } from '@ant-design/icons';
import { useEmployees } from './EmpStore';
import { useEffect, useState } from 'react';
import { Tag, Button } from 'antd';
import EmployeeProfileModal from './EmployeeProfileModal';
import PayrollReportModal from './PayrollReportModal';

function Employees(props) {
    let { employees, getEmployees, deleteEmp } = useEmployees()
    const [profileId, setProfileId] = useState(null);
    const [profileOpen, setProfileOpen] = useState(false);
    const [payrollOpen, setPayrollOpen] = useState(false);

    const openProfile = (id) => { setProfileId(id); setProfileOpen(true); };

    useEffect(() => {
        getEmployees()
    }, [])

    return (
        <div>
            <EmployeeProfileModal
                open={profileOpen}
                employeeId={profileId}
                onClose={() => setProfileOpen(false)}
            />
            <PayrollReportModal
                open={payrollOpen}
                onClose={() => setPayrollOpen(false)}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                <Button type="primary" ghost icon={<FileDoneOutlined />} onClick={() => setPayrollOpen(true)}>
                    Maosh vedomosti
                </Button>
            </div>
            <DTable
                pageName={"Xodimlaringiz"}
                addwidth={1000}
                columns={[
                    {
                        title: 'ID',
                        dataIndex: 'id',
                        key: 'id',
                    },
                    {
                        title: 'Rasm',
                        dataIndex: 'avatar',
                        key: 'avatar',
                        render: (text) => <img src={process.env.REACT_APP_URL + text} alt="avatar" style={{ width: '50px', height: '50px' }} />,
                    },
                    {
                        title: 'Ism familya',
                        dataIndex: 'fullname',
                        key: 'fullname',
                        render: (v, rec) => (
                            <a onClick={() => openProfile(rec.id)} style={{ fontWeight: 600 }}>{v}</a>
                        ),
                    },
                    {
                        title: 'Telefon',
                        dataIndex: 'phone',
                        key: 'phone',
                    },
                    {
                        title: 'JSHSHIR',
                        dataIndex: 'jshshir',
                        key: 'jshshir',
                    },
                    {
                        title: 'Manzili',
                        dataIndex: 'region',
                        key: 'region',
                        render: (text, rec) => <><p>{text} - {rec.address}</p></>,
                    },
                    {
                        title: 'Lavozim',
                        dataIndex: 'position_name',
                        key: 'position_name',
                        render: (v) => v ? <Tag color="blue">{v}</Tag> : '—',
                    },
                    {
                        title: 'Maosh',
                        dataIndex: 'salary',
                        key: 'salary',
                        render: (maosh, rec) => <>{maosh ? Number(maosh).toLocaleString() : 0} so'm / {rec.salary_type || 'oylik'}</>  
                    },
                    {
                        title: 'Holat',
                        dataIndex: 'work_status',
                        key: 'work_status',
                        render: (v) => {
                            const map = { active: { c: 'green', l: 'Faol' }, on_leave: { c: 'orange', l: "Ta'tilda" }, fired: { c: 'red', l: 'Ishdan bo\'shgan' } };
                            const s = map[v] || { c: 'default', l: v || '—' };
                            return <Tag color={s.c}>{s.l}</Tag>;
                        },
                    },
                    {
                        title: "Ro'yxatga olingan",
                        dataIndex: 'created',
                        key: 'created',
                        render: (v) => v ? String(v).slice(0, 10) : '—',
                    },
                    {
                        title: 'Profil',
                        key: 'profile',
                        render: (_, rec) => (
                            <Button size="small" type="primary" ghost icon={<IdcardOutlined />}
                                onClick={() => openProfile(rec.id)}>
                                Kartochka
                            </Button>
                        ),
                    },

                ]}
                dataSource={employees}
                AddComponent={Add}
                selectable={true}
                searchable={true}
                EditComponent={Edit}
                addModalTitle="Yangi ishchi qo'shish"
                editModalTitle="Ishchini tahrirlash"
                onRefresh={() => { }}
                onDelete={deleteEmp}
                stats={[
                    { label: 'Jami xodimlar', value: employees.length, icon: <TeamOutlined />, bg: '#eef2ff', color: '#667eea' },
                    { label: 'Faol', value: employees.filter(e => e.work_status === 'active').length, icon: <CheckOutlined />, bg: '#f0fdf4', color: '#22c55e' },
                    { label: 'Ta\'tilda', value: employees.filter(e => e.work_status === 'on_leave').length, icon: <ClockCircleOutlined />, bg: '#fff7ed', color: '#f59e0b' },
                    { label: 'Ishdan bo\'shgan', value: employees.filter(e => e.work_status === 'fired').length, icon: <ExclamationCircleOutlined />, bg: '#fef2f2', color: '#ef4444' },
                ]}
            />
        </div>
    );
}

export default Employees;